import queryString from 'query-string'
import { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import MobileFullScreenDialog from '@src/components/shared/MobileFullScreenDialog'

import ManageBrand from './ManageBrand'
import { ManageBrandDialogContextProvider } from './manageBrandsDialogContext'
import { runCloseCallbacks } from './useManageBrandDialog'

const ManageBrandDialog: React.FC<React.PropsWithChildren> = () => {
  const history = useHistory()
  const location = useLocation()

  const {
    manageBrandRetailerId,
    manageBrandInitialTab,
    manageBrandSubtitle,
    manageBrandValidationMode,
    manageBrandShouldHighlightMissing,
  } = queryString.parse(location.search)

  const handleClose = async () => {
    runCloseCallbacks()

    const params = new URLSearchParams(location.search)
    params.delete('manageBrandRetailerId')
    params.delete('manageBrandInitialTab')
    params.delete('manageBrandSubtitle')
    params.delete('manageBrandValidationMode')
    params.delete('manageBrandShouldHighlightMissing')
    history.push({ search: params.toString() })
  }

  const [isValid, setIsValid] = useState(true)

  return (
    <ManageBrandDialogContextProvider
      value={{
        isValid,
        setIsValid,
        validationMode: manageBrandValidationMode,
        shouldHighlightMissing: manageBrandShouldHighlightMissing === 'true',
      }}
    >
      <MobileFullScreenDialog
        fullWidth
        maxWidth="md"
        onClose={handleClose}
        open={!!manageBrandRetailerId}
      >
        <ManageBrand
          retailerId={manageBrandRetailerId}
          initialTab={manageBrandInitialTab}
          subtitle={manageBrandSubtitle}
          onClose={handleClose}
        />
      </MobileFullScreenDialog>
    </ManageBrandDialogContextProvider>
  )
}

export default ManageBrandDialog
